import { useTranslation } from 'react-i18next';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Tabs } from '@treams/treams-ui';

export default function UserFeedbackTabs(props: { user?: graphql.User }) {
	const { t } = useTranslation();

	const hasFeedback = useFeature(graphql.FeatureName.Feedback);
	const hasCompliments = useFeature(graphql.FeatureName.Compliments);

	return (
		<Tabs.Container>
			{props.user && (
				<>
					{hasFeedback && props.user?.viewerCanViewFeedback && (
						<Tabs.Item
							title={t('user.feedback.tab.incoming.title', { name: props.user.firstName })}
							selected
							path={`/users/${props.user.id}/feedback`}
						/>
					)}
					{hasCompliments && (
						<Tabs.Item
							title={t('user.feedback.tab.compliments.title', { name: props.user.firstName })}
							path={`/users/${props.user.id}/feedback/compliments`}
						/>
					)}
				</>
			)}
		</Tabs.Container>
	);
}
